"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _styled = require("./styled");

var TabList = function TabList(_ref) {
  var tabs = _ref.tabs,
      currentTab = _ref.currentTab,
      setCurrentTab = _ref.setCurrentTab,
      labels = _ref.labels;

  var handleOnChange = function handleOnChange(newTab) {
    return function (event) {
      event.preventDefault();
      setCurrentTab(newTab);
    };
  };

  if (!(tabs !== null && tabs !== void 0 && tabs.length)) {
    return null;
  }

  return /*#__PURE__*/_react["default"].createElement(_styled.Container, null, tabs === null || tabs === void 0 ? void 0 : tabs.map(function (tab, index) {
    var _labels$tabs$index, _labels$tabs;

    return /*#__PURE__*/_react["default"].createElement(_styled.Tab, {
      key: tab.id,
      className: (0, _classnames["default"])({
        active: (currentTab === null || currentTab === void 0 ? void 0 : currentTab.id) === tab.id
      }),
      onClick: handleOnChange(tab)
    }, (_labels$tabs$index = labels === null || labels === void 0 ? void 0 : (_labels$tabs = labels.tabs) === null || _labels$tabs === void 0 ? void 0 : _labels$tabs[index]) !== null && _labels$tabs$index !== void 0 ? _labels$tabs$index : tab.label);
  }));
};

var _default = TabList;
exports["default"] = _default;